// extracted by mini-css-extract-plugin
module.exports = {"atom-animation":"CGHeader_atom-animation__2hAk0"};